import { css } from '@emotion/css';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { MarexLogo } from '../../assets/icons';
import { Colors } from '../../styles/colors';

export const LocationLoadingState = (): JSX.Element => {
  return (
    <SkeletonTheme baseColor={Colors.SURFACE} highlightColor="#e6ecf1">
      <div aria-busy="true" aria-label="Loading location">
        <div className={heroStyle}>
          <Skeleton height={'17.5625rem'} borderRadius={0} />
          <MarexLogo className={logoStyle} fill={Colors.WINDOW_GRAY} />
        </div>

        <div className={contentStyle}>
          <div className={circleWithLinesStyle}>
            <Skeleton height={'4rem'} width={'4rem'} borderRadius={50} />
            <div className={circleContentStyle}>
              <Skeleton height={'1.8125rem'} borderRadius={8} />
              <Skeleton height={'1rem'} width={'65%'} borderRadius={6} />
            </div>
          </div>

          <div>
            <Skeleton height={'1.25rem'} borderRadius={6} />
            <Skeleton height={'1.25rem'} width={'80%'} borderRadius={6} />
            <Skeleton height={'1.25rem'} width={'50%'} borderRadius={6} />
          </div>

          <div className={boldContentStyle}>
            <Skeleton height={'3rem'} borderRadius={12} />
          </div>

          {[0, 1, 2].map((row) => (
            <div className={gridContentStyle} key={row}>
              <div className={gridSectionStyle}>
                <Skeleton height={'0.75rem'} width={'60%'} borderRadius={4} />
                <Skeleton height={'1.25rem'} width={'75%'} borderRadius={6} />
              </div>
              <div className={gridSectionStyle}>
                <Skeleton height={'0.75rem'} width={'60%'} borderRadius={4} />
                <Skeleton height={'1.25rem'} width={'75%'} borderRadius={6} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </SkeletonTheme>
  );
};

const heroStyle = css`
  position: relative;
`;

const contentStyle = css`
  padding: 1.5rem;
  padding-bottom: 7rem;
  max-width: 24rem;
  margin: 0 auto;
`;

const circleWithLinesStyle = css`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding-bottom: 1.5rem;
`;

const circleContentStyle = css`
  width: 75%;
  align-self: center;
`;

const boldContentStyle = css`
  padding-top: 1.5rem;
  padding-bottom: 1rem;
`;

const gridSectionStyle = css`
  width: 45%;
  align-self: center;
`;

const gridContentStyle = css`
  display: flex;
  justify-content: space-between;
  padding-top: 1rem;
`;

const logoStyle = css`
  position: absolute;
  z-index: 1;
  top: 1.25rem;
  left: 1.5rem;
`;
